// import React, { useState } from "react";
// import {
//   Box,
//   TextField,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Grid,
// } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import Header from "../../components/Header";
// import { addWeightCalcAction } from "../../redux/actions/weightCalcAction";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import LoadingIndicator from "../../components/loadingIndicator";
// import * as yup from "yup";

// const validationSchema = yup.object().shape({
//     calctype: yup
//       .string()
//       .oneOf(["rating", "gm", "gmc"], "Invalid type")
//       .required("Type is required"),
//     factor: yup.string().required("Factor is required"),
//     weight: yup
//       .number()
//       .min(0, "Weight must be at least 0")
//       .max(100, "Weight cannot exceed 100")
//       .required("Weight is required")
//   });
  

// const CreateWeightCalc = () => {
//   const dispatch = useDispatch();
//   const [err, setErr] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     calctype: "",
//     factor: "",
//     weight: ""
//   });
//   const navigate = useNavigate();

//   const handleBlur = async (e) => {
//     const fieldName = e.target.name;
//     try {
//       await validationSchema.validateAt(fieldName, formData);
//       setErr({ ...err, [fieldName]: "" });
//     } catch (error) {
//       setErr({ ...err, [fieldName]: error.message });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true); 
//       console.log("Form Data Before Validation:", formData); 
//       await validationSchema.validate({ ...formData }, { abortEarly: false });
  
//       const response = await dispatch(addWeightCalcAction(formData));
//       if (response) {
//         toast.success("WeightCalc created successfully");
//         setTimeout(() => {
//           navigate("/weightCalc"); 
//         }, 100); 
//       } else {
//         toast.error("Failed to create WeightCalc");
//       }
//     } catch (error) {
//       console.error("Error submitting data:", error);
//     } finally {
//       setLoading(false); 
//     }
//   };
  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: name === 'weight' ? Number(value) : value });
//   };
  
//   return (
//     <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
//       <Header title="CREATE WEIGHT CALCULATION" />
//       <form onSubmit={handleSubmit}>
//         <FormControl fullWidth margin="normal">
//           {/* CALCTYPE */}
//           <FormControl fullWidth variant="outlined" margin="normal">
//             <InputLabel>Type</InputLabel>
//             <Select
//               name="calctype"
//               value={formData.calctype}
//               onBlur={handleBlur}
//               onChange={handleChange}
//             >
//               <MenuItem value="rating">Rating</MenuItem>
//               <MenuItem value="gm">GM</MenuItem>
//               <MenuItem value="gmc">GMC</MenuItem>
//             </Select>
//             {err.calctype && (
//               <Grid item>
//                 <Typography color="error">{err.calctype}</Typography>
//               </Grid>
//             )}
//           </FormControl>

//           {/* FACTOR */}
//           <TextField
//             label="Factor"
//             name="factor"
//             value={formData.factor}
//             onBlur={handleBlur}
//             onChange={handleChange}
//             margin="normal"
//           />
//           {err.factor && (
//             <Grid item>
//               <Typography color="error">{err.factor}</Typography>
//             </Grid>
//           )}

//           {/* WEIGHT */}
//           <TextField
//             label="Weight"
//             name="weight"
//             type="number"
//             value={formData.weight}
//             onBlur={handleBlur}
//             onChange={handleChange}
//             margin="normal"
//           />
//           {err.weight && (
//             <Grid item>
//               <Typography color="error">{err.weight}</Typography>
//             </Grid>
//           )}

//           {/* SUBMIT BUTTON */}
//           <Grid container justifyContent="center" alignItems="center">
//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               startIcon={<SendIcon />}
//               disabled={loading}
//             >
//               Submit
//             </Button>
//           </Grid>
//         </FormControl>
//       </form>
//       {loading && <LoadingIndicator />}
//     </Box>
//   );
// };

// export default CreateWeightCalc;



import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../components/Header";
import { addWeightCalcAction } from "../../redux/actions/weightCalcAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingIndicator from "../../components/loadingIndicator";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  calctype: yup
    .string()
    .oneOf(["rating", "gm", "gmc"], "Invalid type")
    .required("Type is required"),
  factor: yup.string().required("Factor is required"),
  weight: yup
    .number()
    .min(0, "Weight must be at least 0")
    .max(100, "Weight cannot exceed 100")
    .required("Weight is required")
});

const CreateWeightCalc = () => {
  const dispatch = useDispatch();
  const [err, setErr] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    calctype: "",
    factor: "",
    weight: ""
  });
  const navigate = useNavigate();

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await validationSchema.validate({ ...formData }, { abortEarly: false });

      const response = await dispatch(addWeightCalcAction(formData));
      if (response) {
        toast.success("WeightCalc created successfully");
        setTimeout(() => {
          navigate("/weightCalc"); // Navigate to the list view
          window.location.reload(); // Reload the page after navigation
        }, 100); // Adjust the delay if needed
      } else {
        toast.error("Failed to create WeightCalc");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: name === 'weight' ? Number(value) : value });
  };

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
      <Header title="CREATE WEIGHT CALCULATION" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          {/* CALCTYPE */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Type</InputLabel>
            <Select
              name="calctype"
              value={formData.calctype}
              onBlur={handleBlur}
              onChange={handleChange}
            >
              <MenuItem value="rating">Rating</MenuItem>
              <MenuItem value="gm">GM</MenuItem>
              <MenuItem value="gmc">GMC</MenuItem>
            </Select>
            {err.calctype && (
              <Grid item>
                <Typography color="error">{err.calctype}</Typography>
              </Grid>
            )}
          </FormControl>

          {/* FACTOR */}
          <TextField
            label="Factor"
            name="factor"
            value={formData.factor}
            onBlur={handleBlur}
            onChange={handleChange}
            margin="normal"
          />
          {err.factor && (
            <Grid item>
              <Typography color="error">{err.factor}</Typography>
            </Grid>
          )}

          {/* WEIGHT */}
          <TextField
            label="Weight"
            name="weight"
            type="number"
            value={formData.weight}
            onBlur={handleBlur}
            onChange={handleChange}
            margin="normal"
          />
          {err.weight && (
            <Grid item>
              <Typography color="error">{err.weight}</Typography>
            </Grid>
          )}

          {/* SUBMIT BUTTON */}
          <Grid container justifyContent="center" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              disabled={loading}
            >
              Submit
            </Button>
          </Grid>
        </FormControl>
      </form>
      {loading && <LoadingIndicator />}
    </Box>
  );
};

export default CreateWeightCalc;
